import { Col, Divider, Row, Select } from "antd";
import { ReactSVG } from "react-svg";
import lock from "src/shared/assets/images/landing/lock.svg";
import userCheck from "src/shared/assets/images/landing/user-check.svg";
import clock from "src/shared/assets/images/landing/clock.svg";
import alertCircle from "src/shared/assets/images/landing/alert-circle.svg";
import bot from "src/shared/assets/images/landing/bot.svg";
import "./instaBuyAuto.less";
import { ButtonC } from "src/shared/components";
const LInstaBuyAuto = () => {
  return (
    <section id="buyAuto">
      <Row justify="center" className="h100" align="middle">
        <Col xs={23} lg={20}>
          <Row justify="space-between" align="middle" gutter={[25, 25]}>
            <Col xs={23} md={21} lg={12} xl={9} className="right">
              <h3>
                افزایش لایک، بازدید و کامنت{" "}
                <span className="mark">خودکار </span>
                <br />
                برای پست های آینده
              </h3>
              <p>
                به وسیله این بسته شما می توانید اقدام به خرید فالوور کنید و
                فالوور های اکانت خودتون رو افزایش دهید فالوورهای ارائه شده در
                سایت بسیار با کیفیت و ایرانی هستند
              </p>
              <div className="div-img">
                <ReactSVG src={bot} />
              </div>
            </Col>
            <Col xs={23} md={21} lg={12} xl={9} className="left">
              <div className={`card bg-second`}>
                <div className="div-select" style={{ color: "black" }}>
                  <p style={{ color: "black" }}>سرویس خود را انتخاب کنید</p>
                  <Select placeholder="انتخاب کنید" />
                </div>
                <div className="div-select" style={{ color: "black" }}>
                  <p style={{ color: "black" }}>
                    برای هر پست چه لایک میخواهید؟
                  </p>
                  <Select placeholder="انتخاب کنید" />
                </div>
                <div className="div-select" style={{ color: "black" }}>
                  <p style={{ color: "black" }}>برای چند پست؟</p>
                  <Select placeholder="انتخاب کنید" />
                </div>
                <div className="price">
                  <p style={{ color: "black" }}>قیمت این بسته: </p>
                  <p style={{ color: "black" }}>450000 تومان</p>
                </div>
                <Divider />
                <div className="feature">
                  <ReactSVG src={lock} className="svg" />
                  <span style={{ color: "black" }}>بدون نیاز به پسورد شما</span>
                </div>
                <div className="feature">
                  <ReactSVG src={userCheck} className="svg" />
                  <span style={{ color: "black" }}>فالوور حقیقی</span>
                </div>
                <div className="feature">
                  <ReactSVG src={clock} className="svg" />
                  <span style={{ color: "black" }}>شروع فوری بعد از سفارش</span>
                </div>
                <div className="feature">
                  <ReactSVG src={alertCircle} className="svg" />
                  <span style={{ color: "black" }}>
                    کاملا بی خطر برای پیج شما
                  </span>
                </div>
                <Divider />
                <Row className="ordr-btn-div" justify="center">
                  <Col xs={20} md={18} lg={14}>
                    <ButtonC block>به زودی</ButtonC>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default LInstaBuyAuto;
